import { View } from "ui/atoms/view";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";
import { Portal } from "ui/modules/ThrelsPortal/Portal";
import { ScrollView, Text } from "react-native";
import {
  FormEnums,
  NewFormButtonText,
} from "../../../services/api/types/forms/enums/FormEnums";
import { NoItemsComponent } from "ui/atoms/noItems";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { ReportSummaryList } from "../organisms/ReportSummaryList";
import { ReportStatusEnum } from "../../../services/api/types/reports/enums/ReportStatusEnum";
import { useReportGenerationContext } from "../providers/ReportGenerationProvider";

export function ReportsTemplate() {
  const { showGenerateReportModal, reports, areReportsLoading, newReportIds } =
    useReportGenerationContext();

  const tag = FormEnums.REPORTS;

  const generatingReportsStatuses = [
    ReportStatusEnum.PROCESSING,
    ReportStatusEnum.PENDING,
  ];

  const inProgressReports =
    reports?.filter((r) => generatingReportsStatuses.includes(r.status)) ?? [];

  const otherReports =
    reports?.filter((r) => !generatingReportsStatuses.includes(r.status)) ?? [];

  return (
    <View className="flex-1">
      <Portal hostName="headerButton" identifier="reportsList">
        <Button
          className="mb-3"
          action="primary"
          size="sm"
          onPress={() => showGenerateReportModal()}
        >
          <ButtonText>Generate Report</ButtonText>
          <ButtonIcon as={AddIcon} className="w-4 h-4 ml-2" />
        </Button>
      </Portal>
      <ScrollView contentContainerClassName="px-dashboard flex-1 flex">
        {areReportsLoading ? (
          <LoadingSpinner />
        ) : reports?.length ? (
          <View>
            {inProgressReports.length > 0 && (
              <View>
                <View className="gap-1">
                  <Text className="text-xl font-medium text-typography-700">
                    In Progress
                  </Text>
                  <Text className="text-sm font-normal text-typography-600">
                    Your report(s) are currently being prepared. You will be
                    notified once they are ready.
                  </Text>
                </View>
                <ReportSummaryList reports={inProgressReports} />
                <View className="border-b border-gray-200 w-full my-10" />
              </View>
            )}

            {otherReports.length > 0 && (
              <View>
                <Text className="text-xl font-medium text-typography-700">
                  All reports
                </Text>
                <ReportSummaryList
                  reports={otherReports}
                  newReportIds={newReportIds}
                />
              </View>
            )}
          </View>
        ) : (
          <NoItemsComponent
            className="py-5"
            title="No reports!"
            subtitle={` Click on the "${NewFormButtonText[tag]}" button above to create your first report`}
          />
        )}
      </ScrollView>
    </View>
  );
}
